<template lang="pug">
	layout-modal
		p As you may be aware we have been working closely with the Welsh Local Authority Data Protection Officers (DPOs) to update our data processing agreement. This is the agreement between your school and Wonde. If you require more information please <a href="https://www.wonde.com/wp-content/uploads/FAQS-Data-Processing-Agreement-for-Welsh-State-Schools.pdf" target="_blank">click here</a> or email <a href="mailto:dpo@wonde.com">dpo@wonde.com</a>.
		p I agree to the updated <a href="https://www.wonde.com/wp-content/uploads/Wonde-Data-Processing-Agreement-for-Welsh-State-Schools.docx-1-1.pdf" target="_blank">Data Processing Agreement</a>
		template(slot="footer")
			el-button(type="danger", @click.prevent="$vuedals.close(false)") Close
			el-button(type="success", @click.prevent="$vuedals.close(true)") Agree
</template>

<script>
export default {
	props: {
		userId: {
			type: String,
			required: true,
		},
	},
	mounted() {
		localStorage.setItem(`${this.userId}-hide_welsh_dha`, true);
	},
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/admin/modals/WelshDHA.vue